<template>
  <v-container>
    <h2 style="color:gray">Cài Đặt Xe tuyến</h2>
    <v-divider class="my-3"></v-divider>
    <v-row>
      <v-col cols="12">
        <v-checkbox
          v-model="policies"
          value="view-bus-group"
          hide-details
          :label="'Cho phép ' + roleName + ' thiết lập xe tuyến'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          v-model="policies"
          value="view-bus"
          :label="'Cho phép ' + roleName + ' xem danh sách xe tuyến'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          v-model="policies"
          value="view-bus-info"
          :label="'Cho phép ' + roleName + ' xem danh sách lái xe'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          v-model="policies"
          value="view-student-register"
          :label="'Cho phép ' + roleName + ' xem danh sách HS đăng kí'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          v-model="policies"
          value="view-student-tracking"
          :label="'Cho phép ' + roleName + ' xem chi tiết học sinh'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          v-model="policies"
          value="view-bus-register-today"
          :label="'Cho phép ' + roleName + ' xem trạng thái di chuyển'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          v-model="policies"
          value="view-bus-report"
          :label="'Cho phép ' + roleName + ' xem báo cáo xe tuyến'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          v-model="policies"
          value="view-bus-map"
          :label="'Cho phép ' + roleName + ' xem theo giõi trực tiếp'"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
    </v-row>

    <v-divider class="my-3"></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text class="mx-5" @click="reset()">Đặt lại</v-btn>
      <v-btn color="primary" @click="save()">Lưu</v-btn>
    </v-card-actions>
  </v-container>
</template>

<script>
import mixins from './helper/mixins'
export default {
  mixins: [mixins]
}
</script>

<style scoped></style>
